import { TFunction } from 'next-i18next';
import {
    FieldInterface,
    FieldSize,
} from 'components/interfaces/GeneralInterface';
import { getField } from 'components/blocks/BasicDetailsInnerBlock';
import { CoachDetailApiInterface } from 'submodules/api_middleware';
import { OverviewBlockType } from 'components/layouts/overview/Overview';
import { getPersonAge, toDate } from 'utils/helpers/datetime';
import { countryFromCode } from 'utils/helpers/browser/translate';
import { TNamespaceEnum } from 'types/types';
import { getTranslation, getTranslationKey } from 'utils/localization';
import { mapIs1GenderRaw } from 'utils/helpers/coach';

interface Props {
    t: TFunction;
    coach: CoachDetailApiInterface;
}

/**
 * Coach detail overview strip. Mirrors the member detail header (ID člena /
 * Věk / Datum narození / Pohlaví / Státní příslušnost) so the two pages stay
 * visually consistent and behave the same way responsively. Field sizes match
 * `getPersonOverview` to reuse its sizebase media queries (50% on <m, 100%
 * on <xxs).
 */
const getCoachOverview = ({ t, coach }: Props): OverviewBlockType => ({
    filterOutUnset: true,
    fields: getCoachOverviewData(t, coach),
});

const getCoachOverviewData = (
    t: TFunction,
    coach: CoachDetailApiInterface
): FieldInterface[] => {
    const gender = mapIs1GenderRaw(coach.gender);
    return [
        getField(t, coach.internal_id ?? undefined, 'MemberProfile.idMember'),
        getField(
            t,
            coach.birth_date
                ? String(getPersonAge(coach.birth_date))
                : undefined,
            getTranslationKey(TNamespaceEnum.person, 'age'),
            FieldSize.P10MW
        ),
        getField(
            t,
            toDate(coach.birth_date),
            getTranslationKey(TNamespaceEnum.person, 'birthDate')
        ),
        getField(
            t,
            gender
                ? getTranslation(t, TNamespaceEnum.person, gender)
                : undefined,
            getTranslationKey(TNamespaceEnum.person, 'gender'),
            FieldSize.P10MW
        ),
        getField(
            t,
            coach.citizen_of ? countryFromCode(t, coach.citizen_of) : undefined,
            getTranslationKey(TNamespaceEnum.person, 'nationality'),
            FieldSize.P25
        ),
    ];
};

export default getCoachOverview;
